<template>
  <q-btn
    data-test-id="current-order-header-icon"
    flat
    :dense="$q.screen.lt.sm"
    round
    icon="fal fa-ticket"
    size="12px"
    :to="{ name: 'consumer:orders' }"
    @click="$trackEvent($customerEvents.CLICKED_CURRENT_ORDER_HEADER_ICON)"
  >
    <q-badge
      v-if="orders.currentOrders.length > 0"
      :label="orders.currentOrders.length"
      color="red"
      floating
    />
  </q-btn>
</template>

<script>
export default {
  name: 'CartButton',
  props: {
    orders: {
      type: Object,
      required: true
    }
  }
}
</script>
